import * as types from './actions';

export const initialState = {
  phoneComfirmed: false,
  phone: '',
  phoneCodeConfirm: [''],
  purePhone: '',
  expectedCode: ''
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.PHONE_CONFIRMED:
      return { ...state, phoneComfirmed: !state.phoneComfirmed };

    case types.PHONE_CHANGE:
      return { ...state, ...payload };

    case types.PHONE_CHANGE_CONFIRMED:
      return { ...state, ...payload };

    case types.PHONE_SET_EXPECTED_CODE:
      return { ...state, expectedCode: payload.expectedCode };
    case 'RESET_STORE':
      return {
        ...state,
        ...initialState,
        phone: payload.fullReset ? initialState.phone : state.phone
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/pages/Phone/reducer.js